import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";

/**
 * Layout Component
 * 
 * Wraps all page routes with consistent layout elements.
 * Currently includes:
 * - Footer (appears on all pages)
 * 
 * This ensures the footer is automatically included on all pages
 * without needing to add it to each page component individually.
 */
const Layout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Main content area - grows to fill available space */}
      <main className="flex-grow">
        <Outlet />
      </main>
      
      {/* Footer - always at the bottom */}
      <Footer />
    </div>
  );
};

export default Layout;

